export class FaturaOnaylaRequest {
    faturaId: number;
    faturaOnaySeviyeId: number;
    isOnay: boolean;
}
